exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Settings-wrapper {\n  max-width: 600px;\n}\n\n.Settings-button-container button {\n  margin: 0px 2px;\n}\n\n.Settings-loading {\n  width: 100%;\n  margin: 40px 0;\n  padding: 30px 50px;\n}\n\n.Settings-container {\n  display: flex;\n  justify-content: center;\n}\n", ""]);

